import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CardNameBroadcastServiceService {

  private CardNameEventEmitter = new EventEmitter<string>();

  constructor() { }

  SetCardName(value: string) {
    this.CardNameEventEmitter.emit(value);
  }

  GetCardName(): EventEmitter<string> {
    return this.CardNameEventEmitter;
  }
}
